/*
 * @Author: your name
 * @Date: 2021-03-30 22:10:31
 * @LastEditTime: 2021-04-25 21:39:42
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \web_page\src\main.js
 */
import Vue from 'vue';
import App from './App.vue';
import './registerServiceWorker';
import router from './router';
import store from './store';
import ElementUI from 'element-ui';
import '@/css/common.css';
import 'element-ui/lib/theme-chalk/index.css';

Vue.use(ElementUI, { size: 'large' });
// 阻止显示生产模式的消息
Vue.config.productionTip = false;
router.beforeEach((to, from, next) => {
    /* 路由发生变化修改页面title */
    if (to.meta.title) {
        document.title = to.meta.title;
    }
    next();
});

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app');
